
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subjects",
      function () {
        return require("private-next-pages/subjects/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subjects"])
      });
    }
  